(() => {
  'use strict';

  const mediaSelector = 'img, picture, svg, canvas';
  const editableSelector = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';

  function protectMedia(media) {
    media.setAttribute('draggable', 'false');
    const link = media.closest('a');
    if (link) {
      link.setAttribute('draggable', 'false');
      link.setAttribute('data-ltt-protected-image', '');
    }
  }

  function protectTree(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(mediaSelector)) protectMedia(root);
    root.querySelectorAll(mediaSelector).forEach(protectMedia);
  }

  function isImageInteraction(event) {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target || target.closest(editableSelector)) return false;
    if (target.closest(`${mediaSelector}, [data-ltt-protected-image]`)) return true;

    // Covers background images and their overlays, including CSS pseudo-elements.
    for (const node of event.composedPath()) {
      if (!(node instanceof Element)) continue;
      if (['', '::before', '::after'].some(pseudo => {
        const background = getComputedStyle(node, pseudo || null).backgroundImage;
        return background && /url\(|image-set\(/i.test(background);
      })) return true;
    }

    // Existing lookbook CSS lets pointer events pass through the image to its wrapper.
    // Only cancel when that pointer actually falls within an image's visible rectangle.
    if (event.clientX === 0 && event.clientY === 0) return false;
    return Array.from(document.querySelectorAll(mediaSelector)).some(media => {
      const rect = media.getBoundingClientRect();
      if (!rect.width || !rect.height || event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) return false;
      const style = getComputedStyle(media);
      return style.visibility !== 'hidden' && style.display !== 'none';
    });
  }

  function preventImageSave(event) {
    if (isImageInteraction(event)) event.preventDefault();
  }

  document.addEventListener('contextmenu', preventImageSave, true);
  document.addEventListener('dragstart', preventImageSave, true);
  protectTree(document.documentElement);

  // Recommendations, cart drawers, quick views and lightbox images arrive after page load.
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(protectTree));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
